var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{class:['alcor-button', { big: _vm.big, flat: _vm.flat, iconOnly: _vm.iconOnly, iconOnlyAlt: _vm.iconOnlyAlt }],attrs:{"to":_vm.localePath(_vm.to, _vm.$i18n.locale),"exact":_vm.exact},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('div',{staticClass:"inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }